class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('CartDrawer');
    if (!this.drawer) return;
    
    this.bindEvents();
  }

  bindEvents() {
    // Close button & overlay click
    this.drawer.addEventListener('click', (e) => {
      if (e.target === this.drawer || e.target.closest('.cart-drawer-close')) {
        this.close();
      }
    });

    // Intercept generic add to cart forms
    document.addEventListener('submit', (e) => {
      if (e.target.matches('form[action="/cart/add"]')) {
        e.preventDefault();
        this.addToCart(new FormData(e.target));
      }
    });

    // Handle Upsell add button
    this.drawer.addEventListener('click', (e) => {
      if (e.target.classList.contains('upsell-add-btn')) {
        const id = e.target.dataset.id;
        if(id) {
          const formData = new FormData();
          formData.append('id', id);
          formData.append('quantity', 1);
          this.addToCart(formData);
        }
      }
    });

    // Quantity updates inside drawer
    this.drawer.addEventListener('click', (e) => {
      const qtyBtn = e.target.closest('.qty-btn');
      const removeBtn = e.target.closest('.cart-item-remove');
      
      if (qtyBtn) {
        const key = qtyBtn.dataset.key;
        const input = this.drawer.querySelector(`.qty-input[data-key="${key}"]`);
        let qty = parseInt(input.value);
        if (qtyBtn.dataset.action === 'plus') qty++;
        if (qtyBtn.dataset.action === 'minus') qty--;
        
        if (qty === 0) {
          this.updateQuantity(key, 0);
        } else {
          this.updateQuantity(key, qty);
        }
      }

      if (removeBtn) {
        this.updateQuantity(removeBtn.dataset.key, 0);
      }
    });

    // Open drawer from header icon
    document.querySelectorAll('a[href="/cart"]').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });
  }

  open() {
    this.drawer.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  addToCart(formData) {
    // Show loading state if needed
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      this.refreshDrawer();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      alert('حدث خطأ أثناء الإضافة للسلة.');
    });
  }

  updateQuantity(key, quantity) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [key]: quantity } })
    })
    .then(response => response.json())
    .then(data => {
      this.refreshDrawer();
    })
    .catch(error => console.error('Error updating cart:', error));
  }

  refreshDrawer() {
    // Use Shopify Section Rendering API
    fetch(`/?section_id=cart-drawer`)
      .then(response => response.text())
      .then(text => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;
        const newDrawer = tempDiv.querySelector('.cart-drawer');
        
        if (newDrawer) {
          this.drawer.querySelector('.cart-drawer').innerHTML = newDrawer.innerHTML;
          
          // Update header cart count
          const newCount = newDrawer.querySelector('.cart-drawer-title').textContent.match(/\d+/);
          const headerCount = document.querySelector('.header-cart .cart-count');
          if (headerCount && newCount) {
            headerCount.textContent = newCount[0];
          }
          
          if (!this.drawer.classList.contains('is-active')) {
            this.open();
          }
        }
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.themeCartDrawer = new CartDrawer();
});
